<template>
    <Head title="Desempenho" />
    <AuthenticatedLayout>
        <Heading title="Desempenho" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28"/>

        <div class="bg-white px-4 pb-4">
            <section class="xl:px-[15.5vw] pt-8 sm:pt-2 flex">
                <div class="max-w-[751px] w-full h-full">
                    <div>
                        <h1 class="text-primary font-bold">Desempenho Equipe</h1>
                        <p>Use o filtro abaixo para ver mais opções.</p>
                    </div>
                    <div class="flex items-center gap-x-4">
                        <FilterTeamPerformance :seasonWeeks="weeks" :regions="regionsOptions" @updateFilter="filterTeamPerformance($event)"/>
                        <a v-if="isFiltered" class="text-blue-600 hover:underline cursor-pointer text-sm" @click="clearFilter()">Limpar Filtro</a>
                    </div>

                    <div class="max-w-[461px] p-8 flex justify-center items-center rounded-2xl bg-gray-100">
                        <div class="h-full w-full flex justify-center items-center rounded-2xl sm:flex-col gap-4">
                            <div class="flex-grow relative xl:max-w-[35%]">
                                <div class="outer w-[120px] h-[120px] rounded-[50%] p-5 bg-[#79FF9D]">
                                    <div class="inner h-[80px] w-[80px] rounded-[50%] flex justify-center items-center bg-white">
                                        <div id="number" class="font-semibold text-primary text-[20px]">
                                            {{progressValue}}%
                                        </div>
                                    </div>
                                </div>
                                <svg class="absolute top-0 left-0" xmlns="http://www.w3.org/2000/svg" version="1.1" width="160px" height="160px">
                                    <defs>
                                    <linearGradient id="GradientColor">
                                        <stop offset="0%" stop-color="#e91e63" />
                                        <stop offset="100%" stop-color="#673ab7" />
                                    </linearGradient>
                                    </defs>
                                    <circle class="progress-bar fill-[none] stroke-[#0771c5] stroke-[20px]" cx="60px" cy="60px" r="50" stroke-linecap="round" />
                                </svg>
                            </div>
                            <div class="pl-[16px] xl:max-w-[35%]">
                                <h1 class="text-primary font-bold">Meta de equipe</h1>
                                <div>Lorem ipsum dolor sit amet, consectetur </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-14">
                        <h1 class="text-primary font-bold">Distribuição de Resultado por Participante</h1>
                        <p> Use o filtro abaixo para ver mais opções.</p>
                    </div>
                    <div class="bg-white rounded-2xl border-primary border p-4 mt-4">
                        <div class="flex flex-col">
                            <section>
                                <div class="text-black font-bold rounded px-4 grid grid-cols-3 border border-transparent">
                                    <p class="pb-6 text-primary border-r-2 border-[#BBB5B5] flex items-center gap-x-2">Nome do participante<Icon name="Seta" class="cursor-pointer" @click="setPropertyName" :class="propertyFilter == 'nameHigher' ? 'rotate-180' : ''"/></p>
                                    <p class="pb-6 text-primary text-center border-r-2 border-[#BBB5B5] flex items-center justify-center gap-x-2">Resultado<Icon name="Seta" class="cursor-pointer" @click="setPropertyResult" :class="propertyFilter == 'resultHigher' ? 'rotate-180' : ''"/></p>
                                    <p class="pb-6 text-primary text-center flex items-center justify-center gap-x-2">Porcentual do Total<Icon name="Seta" class="cursor-pointer" @click="setPropertyTotal" :class="propertyFilter == 'totalHigher' ? 'rotate-180' : ''"/></p>
                                </div>
                                <div v-for="(item, key) in list" :key="key" class="rounded-xl px-4 grid grid-cols-3 grid-cols-ranking-participants border border-[#DBDBDB]">
                                    <div class="border-r-2 border-[#BBB5B5] flex flex-col justify-center items-center">
                                        <p class="flex sm:justify-center py-4">{{item.name}}</p>
                                    </div>
                                    <p class="border-r-2 border-[#BBB5B5] flex items-center justify-center">{{item.result}}</p>
                                    <div class="flex justify-center items-center">
                                        <p class="flex sm:justify-center py-4">{{item.total}}</p>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <!-- <p class="text-[10px]">Última atualização: 22/03/2021 às 15h43</p> -->
                    </div>
                </div>
            </section>
        </div>
    </AuthenticatedLayout>
</template>
<script>
import { Head } from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import Heading from '@/Components/UI/Texts/Heading.vue';
import Icon from '@/Components/UI/Icons/Icon.vue';
import Input from '@/Components/UI/Form/Select.vue'
import FilterTeamPerformance from '@/Components/FilterTeamPerformance.vue'
import FilterIndividualPerformance from '@/Components/FilterIndividualPerformance.vue'
import moment from 'moment';

export default {
    components: {
        AuthenticatedLayout,
        Head,
        Heading,
        Icon,
        Input,
        FilterTeamPerformance,
        FilterIndividualPerformance,
    },
    props: {
        participants: Object,
        campaigns: Object,
        regions: Object
    },
    data() {
        return {
            showFilterPeriod: false,
            showSelectStatus: false,
            marketStatus: '',
            currentList: this.participants,
            propertyFilter: '',
            weeks: [],
            regionsOptions: '',
            progressValue: 50,
            progressCssValue: ''
        }
    },
    mounted() {
        const actualWeek = moment().startOf('isoWeek').format('W');
        const MomentWeek = moment().week(actualWeek).startOf('isoWeek').format('W');
        const hotfix = (actualWeek != MomentWeek)? 1: 0;

        let weeksInYear = moment().isoWeeks();

        for (let weekNumber = 1; weekNumber < weeksInYear + 1; weekNumber++) {
            const momentWeek = moment().week(weekNumber + hotfix);
            const startDay = momentWeek.startOf('week').locale('pt-br');
            const endDay = momentWeek.endOf('week').locale('pt-br');
            const week = {
                name: `Semana ${weekNumber}`,
                start: startDay.format('DD/MM/YYYY'),
                startFormatted: startDay.format('YYYY-MM-DD'),
                end: endDay.format('DD/MM/YYYY'),
                endFormatted: endDay.format('YYYY-MM-DD'),
            }

            this.weeks.push(week);
        }
    },
    computed: {
        list: function() {
            return this.filterByProperty(this.participants, this.propertyFilter)
        },
    },
    methods: {
        filterTeamPerformance(data) {

            this.$inertia.post(
                "/performance/team/filter",
                data,
            );
        },
        filterIndividualPerformance(data) {

            this.$inertia.post(
                "/performance/personal/filter",
                data,
            );
        },
        formatDate(date) {
            let d = new Date(date);

            let options = {
                day: 'numeric',
                month: '2-digit',
            }

            return d.toLocaleString('pt-br', options);
        },
        filterByProperty(array, property) {
            let arrayC = Object.create(array)

            if(property == 'nameHigher') {
                return arrayC.sort(function(a, b){
                    if(a.name < b.name) { return 1; }
                    if(a.name > b.name) { return -1; }
                    return 0;
                })
            }

            if(property == 'nameLower') {
                return arrayC.sort(function(a, b){
                    if(a.name < b.name) { return -1; }
                    if(a.name > b.name) { return 1; }
                    return 0;
                })
            }

            if(property == 'resultHigher') {
                return arrayC.sort(function(a, b){
                    if(a.result < b.result) { return 1; }
                    if(a.result > b.result) { return -1; }
                    return 0;
                })
            }

            if(property == 'resultLower') {
                return arrayC.sort(function(a, b){
                    if(a.result < b.result) { return -1; }
                    if(a.result > b.result) { return 1; }
                    return 0;
                })
            }

            if(property == 'totalHigher') {
                return arrayC.sort(function(a, b){
                    if(a.total < b.total) { return 1; }
                    if(a.total > b.total) { return -1; }
                    return 0;
                })
            }
            if(property == 'totalLower') {
                return arrayC.sort(function(a, b){
                    if(a.total < b.total) { return -1; }
                    if(a.total > b.total) { return 1; }
                    return 0;
                })
            }

            return arrayC
        },
        setPropertyName() {
            this.propertyFilter == 'nameHigher' ? this.propertyFilter = 'nameLower' : this.propertyFilter = 'nameHigher';
        },
        setPropertyResult() {
            this.propertyFilter == 'resultHigher' ? this.propertyFilter = 'resultLower' : this.propertyFilter = 'resultHigher';
        },
        setPropertyTotal() {
            this.propertyFilter == 'totalHigher' ? this.propertyFilter = 'totalLower' : this.propertyFilter = 'totalHigher';
        },

        isZero(value) {
        if(value == 0) {
            return true
        }
        },
        getData(day, month, year){
            if (day < 10){
                day = `0${day.toString()}`
            }
            if (month+1 < 10){
                month = `0${(month+1).toString()}`
            } else {
                month = month+1;
            }
            return `${day}${month}${year}`;
        },

        setInput(input){
            this.currentInput = input;
            console.log(this.currentInput);
        },

        filterPerformance(data) {

            this.$inertia.post('performance',
            data,
            {
                onSuccess: this.showFilter = false
            })
        },
    }
}
</script>
<style scoped>
    .grid-cols-ranking-participants:nth-child(2n+2) {
        background-color: #DBDBDB;
    }
    .progress-bar {
        stroke-dasharray: 320;
        stroke-dashoffset: v-bind(progressCssValue);
        animation: anim 2s linear forwards;
    }
</style>
